module.exports = __webpack_public_path__ + "img/skip-start-circle.6210b3b7.svg";